import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { RentalAgreementsReminderOptions } from '../types/rental-agreements-reminder-options';
import { VehicleInsurancesReminderOptions } from '../types/vehicle-insurances-reminder-options';
import { VehicleRoadTaxesReminderOptions } from '../types/vehicle-road-taxes-reminder-options';
import { VehicleRoadWorthyChecksReminderOptions } from '../types/vehicle-road-worthy-checks-reminder-options';

/**
 * Update reminder preferences DTO
 */
export class UpdateReminderPreferencesDto {
	@TransformInt()
	id!: number;
	color?: string;
	@TransformInt()
	userId?: number;
	enabled!: boolean;
	rentalAgreements?: RentalAgreementsReminderOptions;
	vehicleInsurances?: VehicleInsurancesReminderOptions;
	vehicleRoadTaxes?: VehicleRoadTaxesReminderOptions;
	vehicleRoadWorthyChecks?: VehicleRoadWorthyChecksReminderOptions;
}
